export const formatPrice=(price, currency)=> {
    if (typeof price !== 'number') {
        price = Number(price);
    }
    let symbol = currency === 'TRY' || currency === 'TL' ? '₺' : currency;
    return price.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '' + symbol;
}